"use client";

import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import { useSpotifyPlayer, type JukeboxLaunchTarget } from "./spotify-player-context";

/** Let event cards open this page's jukebox on one of their bills. */
export function useJukeboxLauncher(launch: (target: JukeboxLaunchTarget) => void) {
  const { registerJukeboxLauncher } = useSpotifyPlayer();
  const t = useTranslations("Jukebox");
  const open = t("openInJukebox");
  const reopen = t("reopenJukebox");
  const launchRef = useRef(launch);

  useEffect(() => {
    launchRef.current = launch;
  }, [launch]);

  useEffect(
    () => registerJukeboxLauncher((target) => launchRef.current(target), { open, reopen }),
    [registerJukeboxLauncher, open, reopen]
  );
}
